import React, {Component} from 'react';
import {Chip, Grid, Paper, withStyles} from 'material-ui';
import {connect} from 'react-redux';
import {
    deleteSection,
    discardChanges,
    moveSection,
    updateSectionGroup,
    setPagePreview,
} from '../../actions';
import {builderStyles} from '../../style/builder';
import classNames from 'classnames';
import {toastr} from 'react-redux-toastr';
import DeleteDialog from '../../form/delete_section_dialog';
import {getActiveSections} from '../../selectors/active_sections';
import PageBuilderWarning from '../../builder_warning';
import SectionListSettings from './section_list';
import Sticky from 'react-sticky-el';
//import {showToasterWarningMessage, showToasterInfoMessage} from '../../../../components/helpers/helpers'; // Hide pop-up messages, do not delete yet
import {getPage, savePage} from '../../thunks';
import {getLocations} from '../../../locations/thunks';
import {BackButton} from '../../../../components/buttons/BackButton';
import ScrollToTop from '../../../../components/scroll-top/ScrollToTop';
import TagsDisplayList from '../../tags_display_list';

class PageSectionsSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openDeleteDialog: false,
            toDeleteSectionId: null,
        };
    }

    shouldComponentUpdate(nextProps) {
        return nextProps.pageSections !== null;
    }

    componentWillMount() {
        this.props.getPage(this.props.pageId);
        // Hide pop-up messages for now, in the future find a way to maybe only display them once per session, do not delete yet
        // showToasterWarningMessage('The order in which the sections are saved on this page will reflect the order of the sections on the website!');
        // showToasterInfoMessage('Please enable your browser to ALLOW POP-UPS in order to open the page PREVIEW!');
    }

    componentWillUnmount() {
        toastr.removeByType('warning');
        toastr.removeByType('info');
    }

    handlePageSave() {
        this.props.savePage(
            this.props.pageId,
            this.props.allSections,
            this.props.page,
            false
        );
    }

    handleSavePreview() {
        this.props.savePage(
            this.props.pageId,
            this.props.allSections,
            this.props.page,
            true
        );
    }

    moveTheSection(dragIndex, hoverIndex, dragGroup) {
        const {pageSections, moveSection} = this.props;

        // check if the same group has more than 1 section
        const hasSiblings =
            pageSections.filter(
                (section) =>
                    section.group !== '0' && section.group === dragGroup
            ).length > 1;

        let newPageSections = pageSections[dragIndex];

        if (!hasSiblings) {
            dragGroup = hoverIndex.toString();
            newPageSections = {
                ...pageSections[dragIndex],
                group: dragGroup,
            };
        }

        moveSection(this.props.pageId, dragIndex, hoverIndex, newPageSections);
    }

    async handleDeleteSection() {
        await this.props.deleteSection(
            this.props.pageId,
            this.state.toDeleteSectionId
        );
        await this.setState({
            openDeleteDialog: false,
            toDeleteSectionId: null,
        });
    }

    render() {
        const {pageSections} = this.props;

        const {isOver, canDrop, classes} = this.props;

        let className = '';

        if (isOver && canDrop) {
            className += ' green';
        }

        if (!isOver && canDrop) {
            className += ' yellow';
        }

        if (isOver && !canDrop) {
            className += ' red';
        }

        const buttonClassName = classNames({
            [classes.saveButton]: this.props.loading === false,
            [classes.disabledSaveButton]: this.props.loading === true,
        });

        let saveButtonLabel = this.props.loading ? '' : 'save';

        let pageTagsForDisplay = this.props.tagsForDisplay
            ? this.props.tagsForDisplay
            : '';

        let hasTags = Object.values(pageTagsForDisplay).map((item) => item);

        return (
            <Grid
                className={classNames('pb-sections', className)}
                item
                xs={9}
                sm={9}
            >
                {this.props.isDirty && (
                    <Sticky className={classes.saveWarning}>
                        <PageBuilderWarning
                            page={this.props.page}
                            isDirty={this.props.isDirty}
                            classes={this.props.classes}
                            buttonClassName={buttonClassName}
                            loading={this.props.loading}
                            saveButtonLabel={saveButtonLabel}
                            handlePageSave={this.handlePageSave.bind(this)}
                            handlePageDiscard={() => {
                                this.props.discardChanges();
                                this.props.getPage(this.props.pageId);
                            }}
                            handleSetPreview={this.handleSavePreview.bind(this)}
                        />
                    </Sticky>
                )}

                <Paper elevation={2} className={classes.marginBottom10}>
                    <Chip
                        label={this.props.page.site}
                        className={classes.chipPageWebsite}
                    />
                    <Chip
                        label={
                            <span>
                                Page Type:{' '}
                                <span className={classes.chipTextGreen}>
                                    {this.props.page.type}
                                </span>
                            </span>
                        }
                    />
                    {pageTagsForDisplay && hasTags.join('').length > 0 && (
                        <Chip
                            label={
                                <span className={classes.chipPageTagsLabel}>
                                    Page Tags:{' '}
                                    <span className={classes.chipTextGreen}>
                                        <TagsDisplayList
                                            pageTagsForDisplay={
                                                pageTagsForDisplay
                                            }
                                            classes={classes}
                                        />
                                    </span>
                                </span>
                            }
                            className={classes.chipPageTagsDnd}
                        />
                    )}
                </Paper>

                <SectionListSettings
                    pageSections={pageSections}
                    pageId={this.props.pageId}
                    moveTheSection={this.moveTheSection.bind(this)}
                    showDeleteSectionDialog={(ev, sectionId) => {
                        this.setState({
                            openDeleteDialog: true,
                            toDeleteSectionId: sectionId,
                        });
                    }}
                    changeSectionBgColor={(
                        sectionId,
                        pageId,
                        sectionBgColorId
                    ) =>
                        this.props.changeSectionBgColor(
                            sectionId,
                            pageId,
                            sectionBgColorId
                        )
                    }
                />

                <DeleteDialog
                    open={this.state.openDeleteDialog}
                    handleDelete={this.handleDeleteSection.bind(this)}
                    handleCloseDialog={() => {
                        this.setState({
                            openDeleteDialog: false,
                            toDeleteSectionId: null,
                        });
                    }}
                    classes={this.props.classes}
                />

                <Grid container spacing={0}>
                    <Grid item xs={12} className={classes.buttons}>
                        <BackButton
                            link={'/pages'}
                            variant="raised"
                            className="floatRight"
                        />
                    </Grid>
                </Grid>

                <ScrollToTop />
            </Grid>
        );
    }
}

let checkStateIsDefined = (state, props) => {
    let pageSections =
        state.pageBuilder.pages[props.pageId] == null
            ? []
            : state.pageBuilder.pages[props.pageId].sections;

    let meta =
        state.pageBuilder.pages[props.pageId] == null
            ? []
            : state.pageBuilder.pages[props.pageId].meta;

    let isDirty =
        state.pageBuilder.pages[props.pageId] == null
            ? null
            : state.pageBuilder.pages[props.pageId].isDirty;

    return {pageSections, meta, isDirty};
};

const mapStateToProps = (state, props) => {
    let {pageSections, meta, isDirty} = checkStateIsDefined(state, props);

    return {
        pageSections: getActiveSections(pageSections),
        allSections: pageSections,
        page: meta,
        isDirty: isDirty,
        tagsForDisplay: state.pageBuilder.tagsForDisplay[props.pageId],
        loading: state.layout.ajaxCallsInProgress > 0,
    };
}

export default connect(
    mapStateToProps,
    {
        getPage,
        getLocations,
        moveSection,
        savePage,
        deleteSection,
        updateSectionGroup,
        discardChanges,
        setPagePreview,
    }
)(withStyles(builderStyles)(PageSectionsSettings));



// WEBPACK FOOTER //
// ./src/containers/builder/sections/tab_dnd/sections.js